// src/contexts/CompetitionContext.js
import React, { createContext, useState, useEffect, useCallback } from 'react';
import { fetchCompetition } from '../services/CompetitionService';

export const CompetitionContext = createContext();

export const CompetitionProvider = ({ children }) => {
  const [competition, setCompetition] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isUserJoined, setIsUserJoined] = useState(false);

  const loadCompetition = useCallback(async () => {
    try {
      setIsLoading(true);
      const competitionData = await fetchCompetition();
      setCompetition(competitionData);

      const username = localStorage.getItem('Username');
      const userParticipation = competitionData.competitors.some(competitor => competitor.username === username);
      setIsUserJoined(userParticipation);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadCompetition();
  }, [loadCompetition]);

  return (
    <CompetitionContext.Provider value={{ competition, isLoading, setIsLoading, error, isUserJoined, setIsUserJoined, setCompetition }}>
      {children}
    </CompetitionContext.Provider>
  );
};
